import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProviderActions } from './provider.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { inject } from '@angular/core';
import { ProvidersService } from '@ipensii/shared/data-access-shared';

export class ProviderEffects {
  private readonly actions$ = inject(Actions);
  private readonly providersService = inject(ProvidersService);

  //noinspection JSUnusedLocalSymbols
  private readonly loadProviders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProviderActions.loadProviders),
      switchMap(() =>
        this.providersService.findAll().pipe(
          map((providers) => ProviderActions.loadProvidersSuccess({ providers })),
          catchError((error) => of(ProviderActions.loadProvidersError({ error })))
        )
      )
    )
  );
}
